"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stopUILoading;
var _types = require("./types");
function stopUILoading(key) {
  return function (dispatch) {
    var action = {
      type: _types.UI_LOADING_END,
      key: key
    };
    dispatch(action);
  };
}